module.exports = __webpack_public_path__ + "static/media/figuretext-3.ee04bd18.png";